/* Hauloft v40 · movimiento y ficha (10-oct-2026, BRIEF-ANIMACION-V40 T1, T3, T4, T5, T6). Sin librerías. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* T1 + T4 · videos con data-hl-autoplay: play solo en pantalla; con movimiento reducido no arrancan. */
  const vids = document.querySelectorAll('video[data-hl-autoplay]');
  if (vids.length && !reduce && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver((es) => es.forEach((e) => {
      const v = e.target;
      if (e.isIntersecting) { v.play().catch(() => {}); } else { v.pause(); }
    }), { threshold: 0.35 });
    vids.forEach((v) => vio.observe(v));
  }
  if (reduce) document.querySelectorAll('video[autoplay]').forEach((v) => { v.pause(); v.removeAttribute('autoplay'); });

  /* T3 · botón de pausa del marquee */
  const mq = document.querySelector('[id$="__marquee_hl"]');
  if (mq && !reduce) {
    const b = document.createElement('button');
    b.type = 'button'; b.className = 'hl-mq-btn';
    const ico = { pause: '<svg viewBox="0 0 12 12"><rect x="2" y="1" width="3" height="10"/><rect x="7" y="1" width="3" height="10"/></svg>', play: '<svg viewBox="0 0 12 12"><path d="M3 1l8 5-8 5z"/></svg>' };
    const set = (p) => { mq.classList.toggle('hl-paused', p); b.innerHTML = p ? ico.play : ico.pause; b.setAttribute('aria-label', p ? 'Play scrolling text' : 'Pause scrolling text'); b.setAttribute('aria-pressed', p ? 'true' : 'false'); };
    b.addEventListener('click', () => set(!mq.classList.contains('hl-paused')));
    set(false); mq.appendChild(b);
  }

  /* T5 · puntos sobre la foto real del hero (posiciones en % de la foto 1:1 hauloft-harness-golden-wearing-black.jpg) */
  const heroImg = document.querySelector('[id$="__hero_v40"] img');
  if (heroImg) {
    const host = heroImg.parentElement;
    host.classList.add('hl-hs-host');
    const pts = [
      { x: 64, y: 24, t: 'Top handle', n: 1, side: 'right' },
      { x: 38, y: 71, t: 'Front clip', n: 2, side: 'left' },
      { x: 66, y: 40, t: 'Quick-release buckles', n: 3, side: 'left' }
    ];
    const wrap = document.createElement('div');
    wrap.className = 'hl-hs';
    wrap.innerHTML = pts.map((p) => {
      const target = document.getElementById('hl-how-' + p.n) ? '#hl-how-' + p.n : '/products/hauloft-tactical-dog-harness-no-pull-dual-handle-reflective-1000d-nylon';
      return `<a class="hl-hs__pt hl-hs__pt--${p.side}" href="${target}" style="left:${p.x}%;top:${p.y}%" aria-label="${p.t}: see close-up"><span class="hl-hs__dot"></span><span class="hl-hs__line"></span><span class="hl-hs__lbl">${p.t}</span></a>`;
    }).join('');
    host.appendChild(wrap);
    const items = wrap.querySelectorAll('.hl-hs__pt');
    const show = () => {
      wrap.classList.add('hl-on');
      items.forEach((el, i) => { el.style.transitionDelay = reduce ? '0s' : (i * 0.35) + 's'; el.querySelectorAll('.hl-hs__line,.hl-hs__lbl').forEach((c) => { c.style.transitionDelay = reduce ? '0s' : (i * 0.35 + 0.2) + 's'; }); setTimeout(() => el.classList.add('hl-pulse'), reduce ? 0 : 600 + i * 350); });
    };
    if (reduce || !('IntersectionObserver' in window)) { show(); }
    else {
      const hio = new IntersectionObserver((es) => { if (es.some((e) => e.isIntersecting)) { show(); hio.disconnect(); } }, { threshold: 0.4 });
      hio.observe(host);
    }
  }

  /* T6 · ficha del arnés: comparativa justo bajo la ficha principal */
  const cmp = document.querySelector('[data-hl-compare]');
  if (cmp) {
    const sec = cmp.closest('.shopify-section') || cmp;
    const main = document.querySelector('main > .shopify-section[id$="__main"]') || document.querySelector('product-information')?.closest('.shopify-section');
    if (main && main.parentNode) main.parentNode.insertBefore(sec, main.nextSibling);

    /* T6a: el botón fijo lo trae Horizon (enable_sticky_add_to_cart, "$49.99 Add to cart"); no se duplica. */
  }
})();

// v42 (22-oct-2026): on products with a Size option, Add to cart waits until the shopper taps a size
// (the theme preselects the first size, S, and the sticky bar would add it in one tap).
(function () {
  var sizes = Array.prototype.slice.call(document.querySelectorAll('input[type="radio"][name^="Size-"]'));
  if (!sizes.length) return;
  var picked = /[?&]variant=/.test(location.search);
  sizes.forEach(function (i) {
    i.addEventListener('click', function () { picked = true; });
    i.addEventListener('change', function () { picked = true; });
  });
  document.addEventListener('click', function (e) {
    if (picked) return;
    var btn = e.target.closest && e.target.closest('.sticky-add-to-cart__button, .add-to-cart-button');
    if (!btn) return;
    e.preventDefault(); e.stopImmediatePropagation();
    var box = sizes[0].closest('fieldset') || sizes[0].parentElement;
    box.scrollIntoView({ behavior: 'smooth', block: 'center' });
    box.classList.add('hl-pick-size');
    setTimeout(function () { box.classList.remove('hl-pick-size'); }, 2500);
  }, true);
})();

